<template>
    <div class="fixed z-50 top-36 right-0 flex">
        <button
            type="button"
            class="h-14 w-14 bg-white border border-r-0 rounded-bl-lg md:rounded-tl-lg"
            @click="open"
        >
            <span class="flex h-full flex-col justify-center items-center">
              <svg width="22" height="22" xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" stroke-width="1.5" stroke="currentColor">
                <path stroke-linecap="round" stroke-linejoin="round" d="M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 011.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.56.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.893.149c-.425.07-.765.383-.93.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 01-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.397.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 01-.12-1.45l.527-.737c.25-.35.273-.806.108-1.204-.165-.397-.505-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.107-1.204l-.527-.738a1.125 1.125 0 01.12-1.45l.773-.773a1.125 1.125 0 011.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894z" />
                <path stroke-linecap="round" stroke-linejoin="round" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
              </svg>

            </span>
        </button>

      <large-modal
        :show="showModal"
        title="Settings"
        subtitle="Proposal settings"
        @close="close"
        >
        <main class="max-w-3xl p-8">
          <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
            <label class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> Client </label>
            <div class="mt-2 sm:mt-0 sm:col-span-2">
              <DynamicDropdown
                v-model="form.client"
                search-url="/api/clients?search="
                initial-url="/api/clients"
                placeholder="Select client"
                :modal="true"
              >

                <template #modal="{ showModal, query, select, closeModal }">
                  <CreateClientModal
                    :query="query"
                    :show="showModal"
                    @close="closeModal"
                    @created="select"
                  />
                </template>
              </DynamicDropdown>
              <p
                v-if="form.errors.client_id"
                class="mt-2 text-sm text-red-600"
              >
                {{ form.errors.client_id }}
              </p>
            </div>
          </div>

          <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start pt-8">
            <label class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> Project </label>
            <div class="mt-2 sm:mt-0 sm:col-span-2">

              <DynamicDropdown
                v-model="form.project"
                :search-url="'/api/clients/' + form.client?.id + '/projects?search='"
                :initial-url="'/api/clients/' + form.client?.id + '/projects'"
                :disabled="!form.client?.id"
                placeholder="Select projects"
                :modal="true"
              >

                <template #modal="{ showModal, query, select, closeModal }">
                  <CreateProjectModal
                    :query="query"
                    :show="showModal"
                    @close="closeModal"
                    :client="form.client"
                    @created="select"
                  />
                </template>

              </DynamicDropdown>
              <p
                v-if="form.errors.project_id"
                class="mt-2 text-sm text-red-600"
              >
                {{ form.errors.project_id }}
              </p>
            </div>
          </div>

          <hr class="my-8">

          <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start pt-8">
            <label class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> Travel date (from-to) </label>
            <div class="mt-2 sm:mt-0 sm:col-span-2">
              <Datepicker
                v-model="form.range"
                :enableTimePicker="false"
                range
              />
              <p
                v-if="form.errors.range"
                class="mt-2 text-sm text-red-600"
              >
                {{ form.errors.range }}
              </p>
            </div>
          </div>

          <hr class="my-8">

          <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start">
            <label class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> Number of travelers </label>
            <div class="mt-2 sm:mt-0 sm:col-span-2">
              <input
                id="pax"
                v-model="form.pax"
                name="pax"
                type="number"
                min="0"
                oninput="validity.valid||(value='')"
                class="block max-w-lg w-full shadow-sm focus:ring-indigo-500 focus:border-indigo-500 sm:text-sm border-gray-300 rounded-md"
                @change="form.clearErrors('pax')"
              >
              <p
                v-if="form.errors.pax"
                class="mt-2 text-sm text-red-600"
              >
                {{ form.errors.pax }}
              </p>
            </div>
          </div>

          <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start pt-8">
            <label class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2"> Budget per traveller </label>
            <div class="mt-2 sm:mt-0 sm:col-span-2">
              <div class="relative mt-1 flex rounded-md shadow-sm">
                <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                            <span class="text-gray-500 sm:text-sm">
                              {{ currency ? currency.symbol : '$' }}
                            </span>
                </div>
                <input
                  id="amount_pr_pax"
                  v-model="form.amount_pr_pax"
                  type="text"
                  name="amount_pr_pax"
                  placeholder="0.00"
                  autocomplete="username"
                  class="pl-11 focus:ring-indigo-500 focus:border-indigo-500 block w-full min-w-0 rounded-none rounded-l-md sm:text-sm border-gray-300"
                  @change="form.clearErrors('amount_pr_pax')"
                >
                <span class="flex inline-flex items-center rounded-r-md border border-l-0 border-gray-300 bg-gray-50 text-gray-500 sm:text-sm">
                            <CurrencySelectPicker
                              v-model="form.currency"
                              label=""
                              :borders="false"
                            />
                          </span>
              </div>
              <p
                v-if="form.errors.currency_id || form.errors.amount"
                class="mt-2 text-sm text-red-600"
              >
                {{ form.errors.currency_id }}
                {{ form.errors.amount }}
              </p>
            </div>
          </div>

        </main>
        <template #footer>
          <CreateButton
            class="mr-2"
            :disabled="form.processing"
            :class="{'opacity-50 cursor-not-allowed': form.processing}"
            @click="save"
          >
            Save
          </CreateButton>
          <CancelButton
            class="ml-2"
            @click="close"
          />
        </template>
      </large-modal>
    </div>
</template>

<script setup>
import {onMounted, ref} from 'vue'
import {useProposalOldStore} from "@/Stores/ProposalOld";
import LargeModal from "@/ComponentsDeprecated/Modal/LargeModal";
import { useForm } from '@inertiajs/vue3'
import Datepicker from '@vuepic/vue-datepicker';
import '@vuepic/vue-datepicker/dist/main.css';
import CurrencySelectPicker from '@/ComponentsDeprecated/Select/CurrencySelectPicker';
import CancelButton from '@/ComponentsDeprecated/Buttons/CancelButton';
import CreateButton from '@/ComponentsDeprecated/Buttons/CreateButton';
import DynamicDropdown from "@/ComponentsDeprecated/Select/DynamicDropdown";
import CreateClientModal from "@/ComponentsDeprecated/Modal/CreateClientModal";
import CreateProjectModal from "@/ComponentsDeprecated/Modal/CreateProjectModal";

const showModal = ref(false)
const store = useProposalOldStore()

const form = useForm({
  client: store.proposal.client,
  project: store.proposal.project,
  range: [store.proposal.start_date, store.proposal.end_date],
  pax: store.proposal.pax,
  amount_pr_pax: store.proposal.amount_pr_pax,
  currency: store.proposal.currency,
})

function close() {
  showModal.value = false
}
function save() {
  form.transform((data) => ({
    client_id: data.client?.id ?? null,
    project_id: data.project?.id ?? null,
    range: data.range,
    pax: data.pax,
    currency_id: data.currency?.id ?? null,
    amount_pr_pax: data.amount_pr_pax,
  })).put(route('proposals.update', store.proposal.id), {
    preserveScroll: true,
    preserveState: false,
    onSuccess: () => {
        showModal.value = false
    }
  })
}
function open() {
  showModal.value = true
}

</script>
